import aren from '../assets/quiz/aren.jpg'
import blackclover from '../assets/quiz/blackclover.jpg'
import drStone from '../assets/quiz/drStone.jpg'
import jotaro from '../assets/quiz/jotaro.jpg'
import jujutsu from '../assets/quiz/jujutsu.jpeg'
import myhero from '../assets/quiz/myhero.jpg'
import opm from '../assets/quiz/opm.jpeg'
import promise_neverland from '../assets/quiz/promise_neverland.jpg'
import Tengen from '../assets/quiz/Tengen.jpg'
import slime from '../assets/quiz/slime.jpg'

export const quiz = [
    {
        question: 'What is anime name = ?',
        image: aren,
        option: [
            {
                choice: 1,
                text: 'attack on titan'
            },
            {
                choice: 2,
                text: 'defense on titan'
            },
            {
                choice: 3,
                text: 'attack on tiny'
            },
            {
                choice: 4,
                text: 'attack on title'
            }
        ],
        answer: 1
    },
    {
        question: 'What is anime name = ?',
        image: blackclover,
        option: [
            {
                choice: 1,
                text: 'black space'
            },
            {
                choice: 2,
                text: 'black clover'
            },
            {
                choice: 3,
                text: 'black heart'
            },
            {
                choice: 4,
                text: 'black diamon'
            }
        ],
        answer: 2
    },
    {
        question: 'What is anime name = ?',
        image: drStone,
        option: [
            {
                choice: 1,
                text: 'dr. Stock'
            },
            {
                choice: 2,
                text: 'dr. Stone'
            },
            {
                choice: 3,
                text: 'dr. Stun'
            },
            {
                choice: 4,
                text: 'dr. Slump'
            }
        ],
        answer: 2
    },
    {
        question: 'What is anime part = ?',
        image: jotaro,
        option: [
            {
                choice: 1,
                text: 'Phantom Blood'
            },
            {
                choice: 2,
                text: 'Stone Ocean'
            },
            {
                choice: 3,
                text: 'Golden Wind'
            },
            {
                choice: 4,
                text: 'Starduct Crusaders'
            }
        ],
        answer: 4
    },
    {
        question: 'What is anime name = ?',
        image: jujutsu,
        option: [
            {
                choice: 1,
                text: 'jujutsu kaisen'
            },
            {
                choice: 2,
                text: 'jujutsu maiden'
            },
            {
                choice: 3,
                text: 'jujutsu raiden'
            },
            {
                choice: 4,
                text: 'jujutsu raisen'
            }
        ],
        answer: 1
    },
    {
        question: 'What is middle guys name = ?',
        image: myhero,
        option: [
            {
                choice: 1,
                text: 'totoroki'
            },
            {
                choice: 2,
                text: 'tokyoki'
            },
            {
                choice: 3,
                text: 'todoroki'
            },
            {
                choice: 4,
                text: 'takoyaki'
            }
        ],
        answer: 3
    },
    {
        question: 'What is his name = ?',
        image: opm,
        option: [
            {
                choice: 1,
                text: 'Saitama'
            },
            {
                choice: 2,
                text: 'Mob'
            },
            {
                choice: 3,
                text: 'One punch man'
            },
            {
                choice: 4,
                text: 'Egg face'
            }
        ],
        answer: 1
    },
    {
        question: 'What is anime name = ?',
        image: promise_neverland,
        option: [
            {
                choice: 1,
                text: 'Promise all'
            },
            {
                choice: 2,
                text: 'Promised neverland'
            },
            {
                choice: 3,
                text: 'Promised netherland'
            },
            {
                choice: 4,
                text: 'Promise neverland'
            }
        ],
        answer: 2
    },
    {
        question: 'What is anime name = ?',
        image: Tengen,
        option: [
            {
                choice: 1,
                text: 'kimetsu no yaiba'
            },
            {
                choice: 2,
                text: 'kimetsu no kaiba'
            },
            {
                choice: 3,
                text: 'kimetsu no alibaba'
            },
            {
                choice: 4,
                text: 'kimetsu no moba'
            }
        ],
        answer: 1
    },
    {
        question: 'What is anime name = ?',
        image: slime,
        option: [
            {
                choice: 1,
                text: 'I\'ve Been Killing Slimes for 300 Years and Maxed Out My Level'
            },
            {
                choice: 2,
                text: 'That time I got reincarnated as a slime'
            },
            {
                choice: 3,
                text: 'Attack on slime'
            },
            {
                choice: 4,
                text: 'Slime dunk'
            }
        ],
        answer: 2
    },
]